
document.addEventListener('DOMContentLoaded', function() {
    // Function to retrieve all group names from local storage
    function getAllGroupNames() {
        var groupNames = [];
        for (var i = 0; i < localStorage.length; i++) {
            var key = localStorage.key(i);
            if (localStorage.getItem(key)) {
                try {
                    // Assuming the group names are those that match the format you've used
                    var groupData = JSON.parse(localStorage.getItem(key));
                    if (Array.isArray(groupData)) {
                        groupNames.push(key);
                    }
                } catch (e) {
                    console.log("Skipping non-group entry:", key);
                }
            }
        }
        return groupNames;
    }

    // Function to retrieve the group data by group name
    function getGroupData(groupName) {
        var groupData = localStorage.getItem(groupName);
        if (groupData) {
            try {
                return JSON.parse(groupData);
            } catch (e) {
                console.log("Error parsing group data for:", groupName);
                return null;
            }
        }
        return null;
    }

    // Retrieve all group names
    var groupNames = getAllGroupNames();

    // Use the group names as needed on this page
    if (groupNames.length > 0) {
        groupNames.forEach(function(groupName) {
            var groupData = getGroupData(groupName);
            if (groupData) {
                console.log("Group Name:", groupName);
                console.log("Group Data:", groupData);

                // Example: You could dynamically create elements based on the group data
                groupData.forEach(function(item) {
                    console.log("Main Product ID:", item.productId);
                    console.log("Shipping Product SKU:", item.shippingId);
                    
                    // Add your logic here to use the group data on the new page
                    // For example, create DOM elements or update the UI with the group info
                });
            }
        });
    } else {
        console.log("No groups found in local storage.");
    }
});
